export enum CampaignStatusEnum {
    ACTIVE = 'active',
    DRAFT = 'draft'
  }
  
  export enum CampaignTargetEnum {
    CONTACT = 'contact',
    PARTNER = 'partner'
  }
  
  export interface CampaignConfig {
    name: string;
  }
  export interface CampaignList {
    id: string;
    campaignConfig: CampaignConfig;
  }
  
  export interface CampaignDetailMessage {
    channel: string;
    subject: string | null;
    body: string;
    timeToSend: string;
  }
  export interface CampaignDetail {
    name: string;
    status: CampaignStatusEnum;
    joined: string;
    finishes: string;
    messages: CampaignDetailMessage[];
  }